/* @flow */
// typecheck: ignore file
import AppLinkActions from 'actions/AppLinkActions';
import AppDownloadImageLinks from 'components/AppDownloadImageLinks.jsx';
import Button from 'components/Button.jsx';
import Field from 'components/Field.jsx';
import FormSingle from 'components/FormSingle.jsx';
import Input from 'components/Input.jsx';
import Label from 'components/Label.jsx';
import React from 'react';
import ToastActions from 'actions/ToastActions';

import './styles/TextAppLinkForm.scss';

export default class extends React.Component {
  state = {
    error: '',
    phoneNumber: '',
    submitting: false,
    valid: false,
  };

  handlePhoneNumberChange = (event: SyntheticEvent) => {
    this.setState({
      error: '',
      // $FlowFixMe
      phoneNumber: event.target.value,
      // $FlowFixMe
      valid: event.target.checkValidity(),
    });
  };

  handlePhoneNumberBlur = (event: SyntheticEvent) => {
    // $FlowFixMe
    if (event.target.value !== '') {
      // $FlowFixMe
      const valid = event.target.checkValidity();

      this.setState({ valid });

      if (!valid) {
        this.setState({ error: 'Invalid phone number' });
      }
    }
  };

  onSubmit = (event: SyntheticEvent) => {
    event.preventDefault();

    const onSuccess = () => {
      ToastActions.showSuccessToast(`Download link sent to ${this.state.phoneNumber}`);
      this.setState({
        phoneNumber: '',
        submitting: false,
        valid: false,
      });
    };

    const onError = () => {
      ToastActions.showErrorToast('Download link not sent. Please try again later.');
      this.setState({ submitting: false });
    };

    this.setState({ submitting: true });

    AppLinkActions
      .sendLink(this.state.phoneNumber)
      .then(onSuccess, onError);
  };

  render() {
    return (
      <div className="TextAppLinkForm">
        <form className="TextAppLinkForm-form" onSubmit={this.onSubmit}>
          <Field error={this.state.error}>
            <Label hidden>Phone number</Label>
            <FormSingle reset="mobile">
              <Input
                type="tel"
                pattern="\+?1?[- .]?\(?\d{3}\)?[- .]?\d{3}[- .]?\d{4}"
                placeholder="(555) 555-5555"
                value={this.state.phoneNumber}
                onBlur={this.handlePhoneNumberBlur}
                onChange={this.handlePhoneNumberChange}
                autoFocus
                required
              />
              <Button
                type="submit"
                level="primary"
                size="small"
                disabled={!this.state.valid || this.state.submitting}>
                Text me a link
              </Button>
            </FormSingle>
          </Field>
        </form>

        <AppDownloadImageLinks align="left" className="TextAppLinkForm-appStores" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/user/components/TextAppLinkForm.jsx